<template>
  <div 
    class="  px-10 mt-12">
    <v-layout wrap>
      <v-flex>
        <section>
          
          <div class="color-dark-blue fs-22 font-weight-bold">
            Tambahkan Invoice Customer
          </div>

          <v-row
            class="">
            <v-col 
              cols="11"
              class="px-0">
              <v-card 
                flat
                style="background: transparent;">
                <v-card-text>
                  <ValidationObserver 
                    ref="form">
                    <v-form>
                      <!-- <div
                        class="mb-4">
                        <div 
                          class="body-2 mb-2">
                          Poto Profil
                        </div>

                        <uploadfolder v-if="form.image_url === ''"
                          v-model="upload.image">
                          <div 
                            slot="activator">
                            <v-card 
                              flat
                              width="200"
                              height="200"
                              class="d-flex align-center justify-center cursor-pointer"
                              style="border-radius: 15px;
                                    border: 2px solid #EBEBEB; 
                                    border-style: dashed;">
                              <v-avatar v-if="!process.image"
                                v-ripple
                                tile 
                                width="200"
                                height="200">
                                <v-icon
                                  size="50"
                                  color="#B9B9B9">
                                  mdi-cloud-upload-outline
                                </v-icon>
                              </v-avatar>

                              <v-progress-circular v-else
                                indeterminate
                                :color="set_color">
                              </v-progress-circular>
                            </v-card>
                          </div>
                        </uploadfolder>

                        <v-card v-if="form.image_url !== ''"
                          flat
                          width="200"
                          height="200"
                          class="d-flex align-center justify-center"
                          style="border-radius: 15px;
                                border: 2px solid #EBEBEB; 
                                border-style: dashed;">
                          <v-avatar
                            v-ripple
                            tile 
                            size="200"
                            style="border-radius: 15px;">
                            <v-img 
                              contain
                              width="100%"
                              height="100%"
                              alt="Distributor Amanata" 
                              :src="form.image_url"
                              class="ma-auto"
                              style="border-radius: 15px;">
                              <template v-slot:placeholder>
                                <v-row
                                  class="fill-height"
                                  align="center"
                                  justify="center">
                                  <v-progress-circular 
                                    indeterminate 
                                    :color="set_color">
                                  </v-progress-circular>
                                </v-row>
                              </template>
                            </v-img>
                          </v-avatar>

                          <v-icon 
                            @click="form.image_url = ''"
                            color="red"
                            class="cursor-pointer"
                            style="position: absolute; top: -10px; right: -10px;">
                            mdi-close-circle
                          </v-icon>
                        </v-card>
                      </div> -->

                      <v-row>

                        <v-col
                          cols="12"
                          md="12" class="pt-0">

                          <ValidationProvider
                            name="No Order" 
                            rules="required" 
                            v-slot="{ errors }">
                            <div 
                              class="fs-15 label-input">
                              No BPB
                            </div>
      
                            <v-autocomplete
                              v-on:keydown.enter.prevent="save()"
                              
                              filled
                              rounded
                              dense
                              solo
      
                              color="#4828a1"
                              placeholder="No BPB"
                              v-on:change="changeOrder()"
                              
      
                              
                              :items="order"
                              item-value="id"
                              item-text="number"
                              :item-color="set_color"
                              spellcheck="false" 
                              :filter="customFilter"
      
                              v-model="form.bpb_id"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">

                              <template v-slot:selection="{ item }">
                                <div
                                  v-if="item" style="color: #4828a1">
                                  {{ item.number }} ({{ item.customer_name }})
                                </div>
                              </template>
                              <template v-slot:item="{ item }">
                                <v-list-item-content>
                                  <v-list-item-title>{{ item.number }}</v-list-item-title>
                                  <v-list-item-subtitle>{{ item.customer_name }}</v-list-item-subtitle>
                                </v-list-item-content>
                              </template>
                            </v-autocomplete>
                          </ValidationProvider>
                        </v-col>
                        
                        <!-- <v-col
                          cols="12"
                          md="6" class="pt-0">

                          <div class="fs-15 label-input">
                          
                            Tanggal Jatuh Tempo
                            <div class="fs-14 font-weight-bold mt-1" v-if="Object.keys(order_json).length > 0">
                              * {{ order_json.customer_term }} hari
                            </div>
                          </div>
            
                          <v-menu
                            v-model="menu2"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                            >
                            <template v-slot:activator="{ on, attrs }">
                              <ValidationProvider 
                                name="Tanggal Jatuh Tempo" 
                                rules="required" 
                                v-slot="{ errors }">
                                <v-text-field
                                  v-model="form.date"
                                  
                                  v-on:keyup.enter="save()"
                                  
                                  filled
                                  solo
                                  rounded
                                  dense
                                  
                                  :color="set_color"
                                  placeholder="Tanggal Jatuh Tempo"
            
                                  :disabled="Object.keys(form).length < 1"
            
                                
            
                                  :error-messages="errors"
                                  required
                                  style="border-radius: 10px;"
                                  readonly
                                  v-bind="attrs"
                                  v-on="on"
                                  >
                                </v-text-field>
                              </ValidationProvider>
                            </template>
                            <v-date-picker
                              v-model="form.date"
                              :min="new Date().toISOString().substr(0, 10)"
                              @input="menu2 = false"
                            ></v-date-picker>
                          </v-menu>
                        </v-col> -->
                        <!-- <v-col
                          cols="12"
                          md="6" class="pt-0">
                          <ValidationProvider
                            name="Biaya Kirim" 
                            rules="required|min_value:0" 
                            v-slot="{ errors }">
                            <div 
                              class="fs-15 label-input">
                              Biaya Kirim
                            </div>
      
                            <v-currency-field
                              v-on:keydown.enter.prevent="save()"
                              
                              filled
                              rounded
                              dense
                              solo
      
                              color="#4828a1"
                              placeholder="Biaya Kirim"
      
                              
                              :error-messages="errors"
                              v-model="form.biaya_kirim"
                              required
                              style="border-radius: 10px;">
                            </v-currency-field>
                          </ValidationProvider>
                        </v-col> -->
                        <!-- <v-col cols="12">
                          <div 
                            class="fs-15 label-input">
                            Catatan
                          </div>
      
                          <v-textarea
                            v-on:keydown.enter.prevent="save()"
                            
                            filled
                            rounded
                            dense
                            solo
      
                            color="#4828a1"
                            placeholder="Catatan"
                            row="3"
      
                            
      
                            v-model="form.note"
                            style="border-radius: 10px;">
                          </v-textarea>
                        </v-col> -->
                      </v-row>

                      <v-card flat style="border-radius: 25px; border: 1px solid #E7E7E7;" class="mt-6 mb-5">
                        <v-card-text>
                          <div class="fs-18 input-label font-weight-bold py-2">
                            Detail BPB
                          </div>
                        </v-card-text>
                      </v-card>

                      <v-card flat style="border-radius: 25px; border: 1px solid #E7E7E7;" class="pb-7 mt-6 mb-5" v-if="Object.keys(order_json).length > 0">
                          <v-card-text>
                            <div class="fs-18 input-label mb-8 font-weight-bold pt-2">
                              No. BPB: {{ order_json.number }}
                            </div>
                          <div v-for="(item, index) in form.varian_arr" :key="index">
                            <!-- {{ index+items.bpb_id }} -->
                            <!-- <table width="100%" style="border-bottom: thin solid #E6EFF5;">
                              <thead>
                                <tr>
                                  <th class="text-left fs-14 font-weight-bold pa-2" style="border-top: thin solid #E6EFF5; border-bottom: thin solid #E6EFF5">Nama Barang</th>
                                  <th class="text-left fs-14 font-weight-bold pa-2" style="border-top: thin solid #E6EFF5; border-bottom: thin solid #E6EFF5">No. SKU</th>
                                  <th class="text-left fs-14 font-weight-bold pa-2" style="border-top: thin solid #E6EFF5; border-bottom: thin solid #E6EFF5">Qty</th>
                                  <th class="text-left fs-14 font-weight-bold pa-2" style="border-top: thin solid #E6EFF5; border-bottom: thin solid #E6EFF5">Qty Lusin</th>
                                  <th class="text-left fs-14 font-weight-bold pa-2" style="border-top: thin solid #E6EFF5; border-bottom: thin solid #E6EFF5">Qty Dus</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="(item, index) in form.varian_arr" :key="index">
                                  <td class="text-left label-input fs-16 font-weight-bold pa-2">{{ item.detail_varian_name }}</td>
                                  <td class="text-left label-input fs-16 font-weight-bold pa-2">{{ item.detail_varian_sku }}</td>
                                  <td class="text-left label-input fs-16 font-weight-bold pa-2">{{ item.detail_qty_pcs_diterima_approved }}</td>
                                  <td class="text-left label-input fs-16 font-weight-bold pa-2">{{ item.detail_qty_lusin_approved }}</td>
                                  <td class="text-left label-input fs-16 font-weight-bold pa-2">{{ item.detail_qty_dus_approved }}</td>
                                </tr>
                              </tbody>
                            </table> -->
                            <v-card flat class="mb-5" style="background: #4828a117; border-radius: 15px;">
                              <v-card-text>
                                <div class="fs-16 font-weight-bold label-input">
                                  {{ item.varian_name }}
                                </div>
                                <div>
                                  <span>Kode SKU</span>: <span>{{ item.varian_sku }}</span>
                                </div>

                                <v-divider class="my-4"></v-divider>

                                <v-row>
                                  <v-col class="py-0 font-weight-medium">
                                    Qty
                                  </v-col>
                                  <v-col class="py-0 font-weight-medium">
                                    Qty Per Pcs
                                  </v-col>
                                  <v-col class="py-0 font-weight-medium">
                                    Harga Per Pcs
                                  </v-col>
                                  <v-col class="py-0 font-weight-medium">
                                    Promo
                                  </v-col>
                                  <v-col class="text-right py-0 font-weight-medium">
                                    Sub Total
                                  </v-col>
                                </v-row>

                                <v-row class="pt-3" v-if="item.qty_pcs_diterima*1 !== 0">
                                  <v-col class="py-0">
              
                                    <div class="fs-17 font-weight-bold label-input">
                                      {{ item.qty_pcs_diterima }} Pcs
                                    </div>
                                  </v-col>
                                  <v-col class="py-0">
              
                                    <div class="fs-17 font-weight-bold label-input">
                                      -
                                    </div>
                                  </v-col>
                                  <v-col class="py-0">
              
                                    <div class="fs-17 font-weight-bold label-input">
                                      {{ item.varian_pricelist_pcs_ppn | price }} 
                                    </div>
                                  </v-col>
                                  <v-col class="py-0">
              
                                    <div class="fs-17 font-weight-bold label-input">
                                      {{ item.varian_discount*1 | price }} 
                                    </div>
                                  </v-col>
                                  <v-col class="text-right py-0">
            
                                    <div class="fs-17 font-weight-bold label-input">
                                      {{ item.detail_price_pcs | price }}
                                    </div>
                                  </v-col>
                                </v-row>

                                <v-row v-if="item.qty_lusin_diterima*1 !== 0">

                                  <v-col class="py-0">
                                    <!-- <div 
                                      class="fs-15 label-input">
                                      Qty Lusin
                                    </div> -->
              
                                    <div class="fs-17 font-weight-bold label-input">
                                      {{ item.qty_lusin_diterima }} Lusin
                                    </div>
                                  </v-col>
                                  <v-col class="py-0">
              
                                    <div class="fs-17 font-weight-bold label-input">
                                      12
                                    </div>
                                  </v-col>
                                  <v-col class="py-0">
              
                                    <div class="fs-17 font-weight-bold label-input">
                                      {{ item.varian_pricelist_pcs_ppn | price }} 
                                    </div>
                                  </v-col>
                                  <v-col class="py-0">
              
                                    <div class="fs-17 font-weight-bold label-input">
                                      {{ item.varian_discount*1 | price }} 
                                    </div>
                                  </v-col>
                                  <v-col class="text-right py-0">
                                    <!-- <div class="fs-15 label-input">
                                      Total
                                    </div> -->
            
                                    <div class="fs-17 font-weight-bold label-input">
                                      {{ item.detail_price_lusin | price }}
                                    </div>
                                  </v-col>
                                </v-row>

                                <v-row v-if="item.qty_dus_diterima*1 !== 0">
                                  <v-col class="py-0">
                                    <!-- <div 
                                      class="fs-15 label-input">
                                      Qty Dus 
                                    </div> -->
                                    <div class="fs-17 font-weight-bold label-input">
                                      {{ item.qty_dus_diterima }} Dus
                                    </div>
                                  </v-col>
                                  <v-col class="py-0">
              
                                    <div class="fs-17 font-weight-bold label-input">
                                      {{ item.varian_total_in_dus*1 }}
                                    </div>
                                  </v-col>
                                  <v-col class="py-0">
              
                                    <div class="fs-17 font-weight-bold label-input">
                                      {{ item.varian_pricelist_pcs_ppn | price }} 
                                    </div>
                                  </v-col>
                                  <v-col class="py-0">
              
                                    <div class="fs-17 font-weight-bold label-input">
                                      {{ item.varian_discount*1 | price }} 
                                    </div>
                                  </v-col>
                                  <v-col class="text-right py-0">
                                    <!-- <div class="fs-15 label-input">
                                      Total
                                    </div> -->
            
                                    <div class="fs-17 font-weight-bold label-input">
                                      {{ item.detail_price_dus | price }}
                                    </div>
                                  </v-col>
                                </v-row>

                                <v-divider class="my-4"></v-divider>

                                <v-row>
                                  <v-col class="label-input font-weight-bold ">
                                    <div>
                                      Total
                                    </div>
                                  </v-col>
                                  <v-col cols="12" md="4">
                                    <div>
                                      
                                    </div>
                                  </v-col>
                                  <v-col cols="12" md="4" class="text-right">
                                    <div class="fs-17 font-weight-bold label-input">
                                      {{ item.detail_price_dus*1 + item.detail_price_lusin*1 + item.detail_price_pcs*1 | price }}
                                    </div>
                                  </v-col>
                                </v-row>

                              </v-card-text>
                            </v-card>



                          </div>
                          <div>
                            <v-card flat style="background: #4828a117; border-radius: 15px;">
                              <v-card-text>
                                <v-row>
                                  <v-col cols="12" md="4">
                                    <div class="label-input font-weight-bold ">
                                      Grand Total
                                    </div>
                                  </v-col>
                                  <v-col cols="12" md="4">
                                    <div>
                                      
                                    </div>
                                  </v-col>
                                  <v-col cols="12" md="4" class="text-right">
                                    <div class="fs-17 font-weight-bold label-input">
                                      {{ total_nominal*1 | price }}
                                    </div>
                                  </v-col>
                                </v-row>
                              </v-card-text>
                            </v-card>
                          </div>

                        </v-card-text>
                      </v-card>
                    </v-form>
                  </ValidationObserver>



                  <div v-if="message.error.length > 0"
                    class="text-center my-4 d-flex align-center">
                    <div
                      class="error--text">
                      <v-icon size="18" color="red">mdi-alert-circle-outline</v-icon>
                      
                      <span
                        class="ml-1">
                        {{ message.error }}
                      </span>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            justify="end"
            class="pa-4 pt-0 pr-1">
            <v-col 
              cols="12"
              md="12"
              class="d-flex align-center justify-end py-0">
              <v-btn 
                @click="save()"
                :loading="process.form"
                :disabled="process.form"
                width="190"
                height="45"
                elevation="0"
                color="#6948c6"
                class="fs-16 white--text text-capitalize border-radius">
                Simpan
              </v-btn>
              
              <v-btn
                to="/finance/invoice"
                :disabled="process.form"
                color="red"
                elevation="0"
                width="140"
                height="45"
                class="body-2 white--text text-capitalize d-flex align-center ml-4 border-radius"
                style="font-weight: 600;">
              
                  Batal
              </v-btn>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        menu: {
          
        },
        category: [
          {
            title: 'Parsial',
            id: 'Parsial'
          },
          {
            title: 'Full',
            id: 'Full'
          }
        ],
        modal: false,
        menu2: false,

        dialog: {
          customer: false,
          fullscreen: false
        },
        bukti: 'gambar',
        gambar_url: '',
        pdf_url: '',
        category: ['Gambar', 'Pdf'],
        pembelian: [],
        product_id: '',
        selected: [],
        headers: [],
        list: [],
        supplier: [],
        form: {
          date: '',
          biaya_kirim: '',
          driver_id: '',
          note: '',
          vehicle_id: '',
          province_name: '',
          city_name: '',
          // order_id: '',
          bpb_arr: [],
          varian_arr: [],
          // category: '',
          // image_url: '',
          // pdf_url: ''
        },
        total_nominal: 0,
        order_json: {},
        varian_arr: [],
        vehicle: [],
        driver: [],
        order: [],
        headers_data: [],
        supervisor: [],
        branch: [],
        province: [],
        city: [],

        mobilephone: {
          name: '',
          id: ''
        },

        lastIndex: 1,

        upload: {
          pdf_url: null,
          image_url: null
        },

        process: {
          form: false,

          pdf_url: false,

          image_url: false
        },
        
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      uploadfolder: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/folder.vue'),
      uploaddocument: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/document.vue')
    },
    watch: {
      'upload.pdf_url': {
        handler: function () {
          if (this.upload.pdf_url) {
            this.process.pdf_url = this.upload.pdf_url.process

            if (!this.process.pdf_url) {
              // CALLBACK FROM UPLOAD IMAGE
              
              this.pdf_url = this.upload.pdf_url.fileuri

              // this.save_image()
            }
          }
        },
        deep: true
      },

      'upload.image_url': {
        handler: function () {
          if (this.upload.image_url) {
            this.process.image_url = this.upload.image_url.process

            if (!this.process.image_url) {
              // CALLBACK FROM UPLOAD IMAGE
              
              this.gambar_url = this.upload.image_url.fileuri

              // this.save_image()
            }
          }
        },
        deep: true
      }
    },
    computed: {
      user () {
        return this.$store.state.user
      },
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      },
      configHeaders () {
          return this.headers_data.filter(header => !header.hide)  
        },
    },
    mounted () {
      this.fetchOrder()
    },
    methods: {
      customFilter (item, queryText, itemText) {
        return (
          item.number.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) >
            -1 ||
          item.customer_name.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1
        );
      },
      async fetchOrder () {
        // this.form.bpb_arr = []
        this.process.load = true

        let params = {
          limit: 1000000,
          is_delivery: '1',
          is_invoice: '0',
          is_warehouse_confirm: '1'
          // status: 'persiapan'
          // limit: 1000000,
          // par_id: '1'
        }

        await get(`admin/bpb/data`, { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.pembelian = res.results.data
            this.order = res.results.data
            
          }
          this.process.load = false
        })
      },
      changeOrder() {
        // this.order_json = []
        // this.varian_arr = []
        this.order_json = this.order.find(x => x.id === this.form.bpb_id)
        this.fetchDetailOrder(this.form.bpb_id)
        // for (let i = 0; i < this.form.bpb_arr.length; i++) {
        //   this.fetchDetailOrder(this.form.bpb_arr[i])
        // }
      },

      async fetchDetailOrder (id) {
        let params = {
          bpb_id: id
        }

        await get('admin/bpb/detail', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            // let data = []
            this.form.varian_arr = []
            // res.results.data.detail.map((item) => {
            //   data.push(item)
            // })
            // this.order_json.res.results.data
            // data.map((item) => {
              // console.log(res.results.data.data)
              this.form.varian_arr=res.results.data.data
              this.form.varian_arr.map((item, index) => {
              item.detail_price_pcs = (item.qty_pcs_diterima*item.varian_pricelist_pcs_ppn) - item.varian_discount*1
              item.detail_price_lusin = (item.qty_lusin_diterima*item.varian_pricelist_pcs_ppn*12) - item.varian_discount*1
              item.detail_price_dus = (item.qty_dus_diterima*item.varian_pricelist_pcs_ppn*item.varian_total_in_dus) - item.varian_discount*1
            })
            this.form.varian_arr.map((item, index) => {
              this.total_nominal += item.detail_price_dus*1 + item.detail_price_lusin*1 + item.detail_price_pcs*1
            })
            // })

            // this.varian_arr.varian_arr = []
            // this.varian_arr.map((items, index) => {
            //   this.varian_arr[index].varian_arr = []
            //   this.varian_arr[index].detail.map((item) => {
            //     this.varian_arr[index].varian_arr.push({
            //       varian_id: item.detail_varian_id,
            //       varian_name: item.detail_varian_name,
            //       varian_sku: item.detail_varian_sku,
            //       qty_pcs_diterima_approve: item.detail_qty_pcs_diterima_approved === undefined ? 0 : item.detail_qty_pcs_diterima_approved*1,
            //       qty_lusin_approve: item.detail_qty_lusin_approved === undefined ? 0 : item.detail_qty_lusin_approved*1,
            //       qty_dus_approve: item.detail_qty_dus_approved === undefined ? 0 : item.detail_qty_dus_approved*1,
            //       qty_pcs_diterima: 0,
            //       qty_lusin: 0,
            //       qty_dus: 0,
                  
            //     })
            //   })
            // })


          }
        })
      },

      async save () {
        this.message.error = ''

        // console.log(dateFormated);
        const isValid = await this.$refs.form.validate()
        if (isValid) {
          var someDate = new Date(this.order_json.diterima_date);
            someDate.setDate(someDate.getDate() + (this.order_json.customer_term*1)); //number  of days to add, e.x. 15 days
            var dateFormated = someDate.toISOString().substr(0,10);
          let form = {
            due_date: dateFormated,
            bpb_id: this.form.bpb_id,
            biaya_kirim: this.form.biaya_kirim,
          }
          this.process.form = true

          // SAVE TO REST API
          await post(`admin/customer_invoice/add`, {
            data: form
          })
          .then((response) => {
            let res = response.data

            this.process.form = false

            if (res.status === 200) {

              this.$router.push({ path: '/finance/invoice' })

            } else {
              this.message.error = res.message
            }
          })
          
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      }
    }
  }
</script>

<style >
table {
  border-collapse: collapse;
  width: 100%;
}

/* tr {
  border-bottom: 1px solid #ddd;
} */
</style>